"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gql = exports.setGQLConfig = exports.setGQLAuthToken = exports.GqlSecuritiesClient = exports.GqlServiceClient = exports.GqlContactsClient = void 0;
const graphql_request_1 = require("graphql-request");
Object.defineProperty(exports, "gql", { enumerable: true, get: function () { return graphql_request_1.gql; } });
const setup_1 = require("./setup");
Object.defineProperty(exports, "setGQLAuthToken", { enumerable: true, get: function () { return setup_1.setGQLAuthToken; } });
Object.defineProperty(exports, "setGQLConfig", { enumerable: true, get: function () { return setup_1.setGQLConfig; } });
const utils_1 = require("./utils");
const GQLclient = (endpoint, operation, params) => {
    const endpointURL = !params
        ? `${endpoint}?${operation}`
        : `${endpoint}?${operation}${(0, utils_1.paramsToString)(params)}`;
    return new graphql_request_1.GraphQLClient(endpointURL, (0, setup_1.getGQLClientOptions)());
};
const GqlContactsClient = (operation, params) => (GQLclient((0, setup_1.getGQLConfig)().clientsEndpoint, operation, params));
exports.GqlContactsClient = GqlContactsClient;
const GqlServiceClient = (operation, params) => (GQLclient((0, setup_1.getGQLConfig)().serviceEndpoint, operation, params));
exports.GqlServiceClient = GqlServiceClient;
const GqlSecuritiesClient = (operation, params) => (GQLclient((0, setup_1.getGQLConfig)().serviceEndpoint, operation, params));
exports.GqlSecuritiesClient = GqlSecuritiesClient;
//# sourceMappingURL=transport.js.map